import { KeycloakService } from 'keycloak-angular';
import { AppService } from 'src/app/app.service';

export function initializer(keycloak: KeycloakService, appService: AppService): () => Promise<any> {
    return (): Promise<any> => {
        return new Promise(async (resolve, reject) => {
            try {
                await appService.load();
                await keycloak.init({
                    config: {
                        url: appService.settings.keycloak.issuer,
                        realm: appService.settings.keycloak.realm,
                        clientId: appService.settings.keycloak.clientId
                    },
                    loadUserProfileAtStartUp: false,
                    initOptions: {
                        onLoad: 'login-required',
                        checkLoginIframe: true
                    },
                    bearerExcludedUrls: []
                });
                resolve();
            } catch (error) {
                reject(error);
            }
        });
    };
}

/*
export function initializer(appService: AppService): () => Promise<any> {
    return (): Promise<any> => {
        return new Promise(async (resolve, reject) => {
            try {
                await appService.load();
                resolve();
            } catch (error) {
                reject(error);
            }
        });
    };
}


export function initializer(appService: AppService) {
    return () => appService.load();
}
*/